import { Colors } from '../../consts/Colors';
export default class Card1 extends Phaser.GameObjects.Container {
    constructor(scene, x, y, cardData, deck) {
        super(scene, x, y, []);

        scene.add.existing(this);
        this.initPosition = { x: x, y: y }
        this.scene = scene;
        this.isDone = false;
        this.img = cardData.image + "Noir"
        this.zoneId = cardData.zoneId;
        this.correct = cardData.correct
        this.incorrect = cardData.incorrect
        this.titre = cardData.titre
        this.index = cardData.index
        this.cardData = cardData

        this.deck = deck

        this.cardImage = this.scene.add.image(0, -30, this.img).setOrigin(0.5);
        this.add(this.cardImage);

        this.rect = this.scene.add.rectangle(0, -30, this.cardImage.width, this.cardImage.height, Colors.Elmt.Blue, 0).setOrigin(0.5);
        // this.rect.setStrokeStyle(8, Colors.Elmt.Orange, 1);
        this.add(this.rect);

        this.setSize(this.cardImage.width, this.cardImage.height);
        this.setInteractive({ useHandCursor: true });
        this.scene.input.setDraggable(this)
    }

    drop(pointer, gameObject, dropZone) {
        let moveX = gameObject.cardData.zoneX - 1700
        let moveY = gameObject.cardData.zoneY - 540
        if (gameObject.zoneId === dropZone.zoneId) {
            this.rect.setStrokeStyle(8, Colors.Elmt.Green, 1);
            dropZone.changeRect()
            this.deck.setDeckTrue(this.correct)
            this.scene.game.data.score.bravo++
        } else {
            dropZone.otherZone.changeRect()
            this.deck.setDeckFalse(this.incorrect)
            this.scene.game.data.score.mauvais++
            this.rect.setStrokeStyle(8, Colors.Elmt.Red, 1);
            this.scene.tweens.add({
                targets: this.rect,
                duration: 400,
                alpha: 0,
                yoyo: true,
                repeat: 4,
                // onComplete: () => {
                //     gameObject.destroy()
                //     dropZone.dropZone.setTint(0xFFFFFF);
                // }
            })

        }

        this.scene.tweens.add({
            delay: 100,
            targets: gameObject,
            duration: 300,
            x: moveX,
            y: moveY,
            scale: 0.8,
            onComplete: () => {
                if (gameObject.zoneId === dropZone.zoneId) {
                    this.scene.addCardOnZone(this.cardData)
                } else {
                    this.scene.addCardOnZone(this.cardData)
                }
                gameObject.destroy()
                dropZone.dropZone.setTint(0xFFFFFF);
            }
        })

        this.scene.newCards.forEach(card => {
            card.setInteractive()
            card.on('pointerout', () => {

                if (card.name === 2 || card.name === 3) {
                    card.setScale(1.4)
                }
                else {
                    card.setScale(1)
                }
            })
            card.on('pointerover', () => {
                if (card.name === 2 || card.name === 3) {
                    card.setScale(1.6)
                }
                else {
                    card.setScale(1.2)
                }
            })
        })
    }

    dragEnd(pointer, gameObject, dropped) {
        if (!dropped) {
            gameObject.resetPosition()
            this.scene.newCards.forEach(card => {
                if (card.isDone) {
                    card.setInteractive()
                    card.on('pointerout', () => {
                        card.setScale(1)
                        // card.setDepth(0)
                    })
                    card.on('pointerover', () => {
                        card.setScale(1.2)
                        // card.setDepth(1)
                    })
                }
            })
        }
    }


    onDrag() {
        this.scene.newCards.forEach(card => {
            // if(card.isDone){
            // card.setDepth(0)
            card.disableInteractive()
            // }
        })
    }

    setDone() {
        this.isDone = true
    }

    resetPosition(duration) {
        if (duration == undefined) {
            duration = 300
        }


        this.scene.tweens.add({
            targets: this,
            duration: duration,
            x: this.initPosition.x,
            y: this.initPosition.y,
            scale: 1,
            onComplete: () => {
                this.setInteractive({ useHandCursor: true })
            }
        })
    }
    dragStartAnnim() {
        this.scene.tweens.add({
            targets: this,
            duration: 200,
            scale: 0.7,
            onComplete: () => {
            }
        })
    }

}